var getTag = {};
export {
  getTag as __exports
};
//# sourceMappingURL=getTag.js.map
